import { graphql } from "relay-runtime"

export const chCreateCallCaseSummaryFeedbackMutation = graphql`
  mutation chCreateCallCaseSummaryFeedbackMutation($input: Ch_createCallCaseSummaryFeedbackInput!) {
    ch_createCallCaseSummaryFeedback(input: $input) {
      callCaseSummaryFeedback {
        appointmentId
        createdAt
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`
